import React, { useState } from 'react';
import { AGENCY_NAME, AGENCY_PASS, GREEN, BLACK } from '../constants';
import { card, mono } from '../styles';
import { Btn, TextInput } from '../components/UI';

export default function LoginScreen({ clients, onLogin }) {
  const [mode, setMode] = useState('agency');
  const [pass, setPass] = useState('');
  const [cid,  setCid]  = useState('');
  const [pin,  setPin]  = useState('');
  const [err,  setErr]  = useState('');

  function tryAgency() {
    if (pass === AGENCY_PASS) onLogin('agency', null);
    else setErr('Wrong password');
  }

  function tryClient() {
    const found = clients.find(c => c.clientId === cid.trim() && c.pin === pin.trim());
    if (found) onLogin('client', found);
    else setErr('Client ID or PIN not found');
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ width: 360 }}>
        <div style={{ textAlign: 'center', marginBottom: 22 }}>
          <div style={{ width: 50, height: 50, background: GREEN, borderRadius: 13, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontWeight: 900, fontSize: 22 }}>
            A
          </div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>{AGENCY_NAME}</div>
          <div style={mono}>Client Platform</div>
        </div>

        <div style={card()}>
          {/* Mode switcher */}
          <div style={{ display: 'flex', background: '#f5f5f2', borderRadius: 9, padding: 3, marginBottom: 16, gap: 2 }}>
            {[['agency', 'Agency'], ['client', 'Client']].map(([m, t]) => (
              <button key={m} onClick={() => { setMode(m); setErr(''); }} style={{
                flex: 1, padding: '7px 0', borderRadius: 7, border: 'none', fontSize: 12, fontWeight: 700,
                background: mode === m ? BLACK : 'transparent',
                color: mode === m ? '#fff' : '#999',
                cursor: 'pointer', fontFamily: 'system-ui, sans-serif',
              }}>{t}</button>
            ))}
          </div>

          {mode === 'agency' ? (
            <div>
              <TextInput label="Password" type="password" value={pass} onChange={e => { setPass(e.target.value); setErr(''); }} ph="Agency password" />
              {err && <p style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>{err}</p>}
              <Btn onClick={tryAgency}>Sign In</Btn>
            </div>
          ) : (
            <div>
              <TextInput label="Client ID" value={cid} onChange={e => { setCid(e.target.value); setErr(''); }} ph="e.g. nova-brand" />
              <TextInput label="PIN" type="password" value={pin} onChange={e => { setPin(e.target.value); setErr(''); }} ph="Your PIN" />
              {err && <p style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>{err}</p>}
              <Btn onClick={tryClient}>Access Portal</Btn>
            </div>
          )}
        </div>

        <p style={{ ...mono, textAlign: 'center', marginTop: 12 }}>
          Agency password: <b style={{ color: BLACK }}>agency2026</b>
        </p>
      </div>
    </div>
  );
}
